<template>
    <div>
        <Header>
            <div class="buttons-right">
                <save-button id="password-save" :status="saving" @save="save" name="Password"></save-button>
            </div>
        </Header>

        <div class="page">
            <div class="block">
                <h3 class="block__heading" v-t="'Change Password'"></h3>
                <field :errors="errors" label="Current Password" name="current_password">
                    <input id="current_password" v-model="formData.current_password" type="password">
                </field>
                <hr class="hr">

                <field :errors="errors" label="New Password" name="new_password">
                    <input id="new_password" v-model="formData.new_password" type="password">
                </field>

                <field :errors="errors" label="Repeat New Password" name="repeat_new_password">
                    <input id="repeat_new_password" v-model="formData.repeat_new_password" type="password">
                </field>

                <p v-t="'You should use at least 8 characters and avoid dictionary words.'"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import SaveButton from '@/components/SaveButton.vue'

    export default {
        components: {
            Header,
            Field,
            SaveButton
        },
        data () {
            return {
                saving: false,
                errors: {},
                formData: {current_password: '', new_password:'', repeat_new_password: ''}
            }
        },
        methods: {
            save () {
                this.errors = {}
                this.saving = true
                this.$http.put('/user/password/', this.formData).then(data => {
                    this.saving = false
                    this.formData.current_password = '';
                    this.formData.new_password = '';
                    this.formData.repeat_new_password = '';
                    this.$store.dispatch('messages/success', this.$t('messages.password-changed'))
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            }
        }
    }
</script>